import GlobalAxios from "../axios/axios-config";
import { IGracePeriodCptParams } from "../models/grace-period-cpt";

const BENEFICIARY_ROUTE = process.env.REACT_APP_APP + "/api/v1/Beneficiary/";

export class BeneficiaryService {
  getGracePeriodAndTemporaryPartialCoverage = (
    params: IGracePeriodCptParams
  ) => {
    return GlobalAxios.get(
      BENEFICIARY_ROUTE + "GetGracePeriodAndTemporaryPartialCoverage",
      { params }
    );
  };
}
